import type { TrainingVideo, TrainingVideoEmbedUrl } from '../types/Training/TrainingVideo'
import { getAll, getOne } from './CommonServices/httpService'

export const listTrainingVideos = async (): Promise<TrainingVideo[]> => {
	const result = await getAll<TrainingVideo[]>(
		'/Trainings',
		'Failed to load training videos for this page',
	)

	return [...result.data].sort((left, right) => left.sortOrder - right.sortOrder)
}

export const getTrainingVideoEmbedUrl = async (tutorialId: number): Promise<TrainingVideoEmbedUrl> => {
	const result = await getOne<TrainingVideoEmbedUrl>(
		`/Trainings/${tutorialId}/EmbedUrl`,
		'Failed to load training video embed URL',
	)

	return result.data
}
